export const POS_TBL_LOADING = "POS_TBL_LOADING";
export const POS_TBL_AREAS = "POS_TBL_AREAS";
export const POS_TBL_TABLES = "POS_TBL_TABLES";
export const POS_TBL_RESERVATIONS = "POS_TBL_RESERVATIONS";
export const POS_TBL_STATUS = "POS_TBL_STATUS";
export const POS_TBL_WAITERS = "POS_TBL_WAITERS";
export const POS_TBL_WAITER_REQUESTS = "POS_TBL_WAITER_REQUESTS";
